import * as Constants from "../constants";
import * as InitialStates from "../constants/initialStates";

export default function livePageReducer(state = InitialStates.getInitialLivePageState(), action) {
  switch (action?.type) {
    case Constants.SET_LIVE_PAGE_INITIAL_STATE: {
      return InitialStates.getInitialLivePageState();
    }
    case Constants.SET_LIVE_PAGE_LOADING: {
      return {
        ...state,
        loading: true,
      };
    }
    default:
      return state;
  }
}
